import {Directive, ElementRef, HostListener} from '@angular/core';

/**
 * otunctan
 */
@Directive({
    selector:'[numbersOnly]',
  standalone: false
})
export class AllowNumberDirective {

    regexStr: string = '^[0-9]+$';

    constructor(private _el: ElementRef) {
    }

    @HostListener('keypress', ['$event'])
    public onKeyPress(event: any) {
        return new RegExp(this.regexStr).test(event.key)
    }

    @HostListener('paste', ['$event'])
    blockPaste(event: ClipboardEvent) {
        this.validationFields(event);
    }

    validationFields(event: ClipboardEvent) {
        event.preventDefault();
        const pasteData = event.clipboardData?.getData('text/plain').replace(/[^0-9]/g, '');
        document.execCommand('insertHTML', false, pasteData);
    }


}
